import Vue from 'vue';
import VueRouter from 'vue-router';
import VueScrollmagic from 'vue-scrollmagic';
import Vue2TouchEvents from 'vue2-touch-events';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';
import VueTheMask from 'vue-the-mask';
import { VueTelInput } from "./components/vue-tel-input/dist/vue-tel-input.esm";
// import VuePhoneNumberInput from 'vue-phone-number-input';
import i18n from './i18n';
import store from './store';
import App from './App.vue';
import Home from "./components/Home.vue";
import ThankYou from './components/ThankYou.vue';

Vue.use(VueTheMask);
Vue.use(VueTelInput);
// Vue.use(VuePhoneNumberInput);
Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.use(Vuelidate);
Vue.use(Vue2TouchEvents);
Vue.use(VueScrollmagic);

Vue.config.productionTip = false;


const routes = [
  { path: '/', component: Home },
  { path: '/thank-you', component: ThankYou },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
